export default __webpack_public_path__ + "static/media/playIcon.abadb09e.svg";